import { createTheme, rem } from '@mantine/core';

/**
 * LeadSync theme — port of LeadSyncTheme.cs (MudBlazor MudTheme).
 * Primary blue + accent palette tuned for the chat UI's pricing-category
 * badges and template-quality colour codes.
 */
export const theme = createTheme({
  primaryColor: 'blue',
  defaultRadius: 'md',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: rem(28) },
      h2: { fontSize: rem(22) },
      h3: { fontSize: rem(18) },
    },
  },
  components: {
    Button: {
      defaultProps: { variant: 'filled' },
    },
    Card: {
      defaultProps: { padding: 'md', radius: 'md', withBorder: true },
    },
  },
});
